import clsx from 'clsx';
import { FC } from 'react';
import featureStyles from '../../RegisterModalShared.module.scss';
import styles from './ThirdStep.module.scss';

interface SignUpTypeProps {
  goToLogin: () => void;
}

export const ThirdStep: FC<SignUpTypeProps> = ({ goToLogin }) => {
  return (
    <section className={featureStyles.content}>
      <h1 className={featureStyles.title}>Reset Password Completed</h1>

      <p className={styles.paragraph}>
        You can now
        <button
          className={clsx(
            featureStyles.link,
            featureStyles['link__button'],
            featureStyles['link--primary']
          )}
          onClick={goToLogin}
        >
          login
        </button>
        with your new password.
      </p>
    </section>
  );
};
